import { Observable } from "rxjs";
import { FunnelFlow } from "../../funnel/register-funnels/funnel-flow-register";

export abstract class RemarketingServiceGateway {
    abstract addPartialCustomer(funnelFlow: FunnelFlow, formStep: string) : Observable<any>;
}